/*
 * A simple model that updates the user's password
 */

define(["backbone", "configuration/properties"], function (Backbone, Properties) {
  var PasswordAdminModel = {};

  PasswordAdminModel.passwordAdminModel = Backbone.Model.extend({
    setNewPassword: function (password) {
      this.set("password", password);
    },
    setOldPassword: function (password) {
      this.set("oldPassword", password);
    },
    url: function () {
      return Properties.rootURL + "/user/password";
    },
  });

  return PasswordAdminModel;
});
